module.exports = __webpack_public_path__ + "media/bell.e6de691c.mp3";